import { ApiProperty } from '@nestjs/swagger';
import { IsString } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { RoleInterface } from '../interfaces/role.interface';

@Exclude()
export class RoleDto extends CommonEntityDto implements RoleInterface {
  @ApiProperty({
    type: 'string',
    title: 'Role',
    description: 'The role name.',
  })
  @IsString()
  @Expose()
  name!: string;
}
